<template>
  <a
    :href="href"
    :target="external ? '_blank' : undefined"
    class="text-white hover:bg-blue-600"
    :class="linkClass"
  >
    {{ text }}
    <span v-if="external && showArrow"> ↗</span>
  </a>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AdminLink",
  props: {
    href: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: false,
    },
    external: {
      type: Boolean,
      default: false,
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
    linkClass: {
      type: String,
      default: "",
    },
  },
});
</script>
